import { Observable } from 'rxjs/observable';
import { BehaviorSubject } from 'rxjs/BehaviorSubject';
import { Injectable } from '@angular/core';


@Injectable()
export class FooterService {

    footerSettings : BehaviorSubject<any> = new BehaviorSubject({
        footerColumns: 1,
        color_var: "light",
        footer_background:"uik-sm-2",
        alpha_level:1
    });
    widgetList : BehaviorSubject<any> = new BehaviorSubject([]);
    alphaLevels : BehaviorSubject<any> = new BehaviorSubject([]);
    footerColumnsArr : BehaviorSubject<any> = new BehaviorSubject([]);
    columnSizes : BehaviorSubject<any> = new BehaviorSubject([]);
    dropdownSettings : BehaviorSubject<any> = new BehaviorSubject([]);
    flexSizes : BehaviorSubject<any> = new BehaviorSubject([]);
    constructor() {
        //Loading Data
        this.widgetList.next( [
            { item_class: "logo", item_text: "Company Logo"},
            { item_class: "social_menu", item_text: "Social"},
            { item_class: "subscribe_form", item_text: "Subscribe Form"},
            { item_class: "payment_menu", item_text: "Payment Menu"},
            { item_class: "links1", item_text: "Links Menu 1"},
            { item_class: "links2", item_text: "Links Menu 2"},
            { item_class: "links3", item_text: "Links Menu 3"}
          ]);
        this.alphaLevels.next([
            { value: "0", name: 0.0},
            { value: "1", name: 0.1},
            { value: "2", name: 0.2},
            { value: "3", name: 0.3},
            { value: "4", name: 0.4},
            { value: "5", name: 0.5},
            { value: "6", name: 0.6},
            { value: "7", name: 0.7},
            { value: "8", name: 0.8},
            { value: "9", name: 0.9}
        ]);
        this.footerColumnsArr.next([
            { value: "1", name: 1},
            { value: "2", name: 2},
            { value: "3", name: 3},
            { value: "4", name: 4},
            { value: "5", name: 5},
            { value: "6", name: 6}
        ]);
        this.columnSizes.next([
            { value: "uik-sm-1", name: 1},
            { value: "uik-sm-2", name: 2},
            { value: "uik-sm-3", name: 3},
            { value: "uik-sm-4", name: 4},
            { value: "uik-sm-5", name: 5},
            { value: "uik-sm-6", name: 6},
            { value: "uik-sm-7", name: 7},
            { value: "uik-sm-8", name: 8},
            { value: "uik-sm-9", name: 9},
            { value: "uik-sm-10", name: 10},
            { value: "uik-sm-11", name: 11},
            { value: "uik-sm-12", name: 12}     
        ]);

        this.flexSizes.next([
            { value: "w10", name: 1},
            { value: "w20", name: 2},
            { value: "w30", name: 3},
            { value: "w40", name: 4},
            { value: "w50", name: 5},
            { value: "w60", name: 6},
            { value: "w70", name: 7},
            { value: "w80", name: 8},
            { value: "w90", name: 9},
            { value: "w100", name: 10}   
        ]);
        
        this.dropdownSettings.next({
            singleSelection: false,
            idField: "item_class",
            textField: "item_text",
            unSelectAllText: "UnSelect All",
            itemsShowLimit: 4,
            enableCheckAll: false,
            allowSearchFilter: false
          });
        if(localStorage.footerSettings){
            this.footerSettings.next(JSON.parse(localStorage.footerSettings));
        }else{
            let footerSettings = this.loadDefaults();
            this.footerSettings.next(footerSettings); 
        }
    }

    setFooterSettings(footerSettings){
        this.footerSettings.next(footerSettings);
    }

    loadDefaults() : any{
        let footerSettings = {
            footerColumns:1,
            widgetList: this.widgetList.getValue(),
            selectedColumnOneList:[
                { item_class: "logo", item_text: "Company Logo"},
                { item_class: "social_menu",item_text: "Social"},
                { item_class: "subscribe_form", item_text: "Subscribe Form"},
                { item_class: "payment_menu", item_text: "Payment Menu"}
            ],
            selectedColumnTwoList: [
                { item_class: "links1", item_text: "Links Menu 1" }
            ],
            selectedColumnThreeList:[
                { item_class: "links2", item_text: "Links Menu 2"}
            ],
            selectedColumnFourList:[
                { item_class: "links3", item_text: "Links Menu 3"}
            ],
            selectedColumnFiveList: [
                { item_class: "links3", tem_text: "Links Menu 3"}
            ],
            selectedColumnSixList:[
                { item_class: "links3", item_text: "Links Menu 3"}
            ],
            dropdownSettings: this.dropdownSettings.getValue(),
            columnOneSize: "uik-sm-6",
            columnTwoSize:              "uik-sm-2",
            columnThreeSize:            "uik-sm-2",
            columnFourSize:             "uik-sm-2",
            columnFiveSize:             "uik-sm-2",
            columnSixSize:              "uik-sm-2",
            footer_background:          "uik-sm-2",
            color_var:                  "light",
            alpha_level:                1
        }
        return footerSettings;
      
    }

}


// WEBPACK FOOTER //
// ./src/Services/FooterService.ts